<template>
  <v-card style="width:480px">
    <v-card-title>
      {{ $t('headerform.title') }}
    </v-card-title>
    <v-card-text>
      <v-btn-toggle :options="contents" v-model="contentType">
      </v-btn-toggle>

      <v-layout class="ma-2" v-if="contentType === 'picture'">
        <file-input
          v-model="header.picture"
          :config="{ label: $t('headerform.labels.picture'), required: true, path: 'headers' }">
        </file-input>
      </v-layout>
      <v-layout class="ma-2" v-if="contentType === 'video'">
        <file-input
          v-model="header.video"
          :config="{ label: $t('headerform.labels.video'), required: true, path: 'headers' }">
        </file-input>
        <file-input
          v-model="header.picture"
          :config="{ label: $t('headerform.labels.pictureForVideo'), path: 'headers' }">
        </file-input>
      </v-layout>
      <text-input
        v-model="header.title"
        :config="{ label: $t('headerform.labels.title'), required: true }">
      </text-input>
      <text-input
        v-model="header.subtitle"
        :config="{ label: $t('headerform.labels.subtitle') }">
      </text-input>
      <text-input
        v-model="header.actionTitle"
        :config="{ label: $t('headerform.labels.actionTitle'), required: true }">
      </text-input>
      <text-input
        v-model="header.actionHref"
        :config="{ label: $t('headerform.labels.actionHref'), required: true }">
      </text-input>
    </v-card-text>
    <v-card-row actions>
      <v-btn block light primary :disabled="!isValid" @click.native.stop="save()">
        {{ $t('headerform.save') }}
      </v-btn>
    </v-card-row>
  </v-card>
</template>

<script>
import { TextInput, FileInput } from '@/components/inputs'
export default {
  components: {
    TextInput,
    FileInput
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      contentType: this.value.video ? 'video' : 'picture',
      header: {
        video: '',
        picture: '',
        title: '',
        subtitle: '',
        actionTitle: '',
        actionHref: '',
        ...this.value
      }
    }
  },
  computed: {
    isValid () {
      return (!!this.header.picture || !!this.header.video) &&
        !!this.header.title &&
        !!this.header.actionTitle &&
        !!this.header.actionHref
    },
    contents () {
      return [
        { text: 'picture', value: 'picture', selected: this.contentType === 'picture' },
        { text: 'video', value: 'video', selected: this.contentType === 'video' }
      ]
    }
  },
  methods: {
    save () {
      this.$emit('saved', this.contentType === 'video' ? {
        ...this.header
      } : {
        ...this.header,
        video: ''
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HeaderForm.vue